import * as Api from 'utils/api';

const basePath = 'application';

export function getSettings(qrCode) {
    const url = Api.buildUrl(`${basePath}/getsettings`, { qrCode });
    return Api.getData(url);
}

export function getCompanyProfileData(qrCode) {
    const url = Api.buildUrl(`${basePath}/getcompanyprofiledata`, { qrCode });
    return Api.getData(url);
}

export function validateQRCode(qrCode) {
    const url = Api.buildUrl(`${basePath}/validateqrcode`, { qrCode });
    return Api.postData(url).then((response) => response.json());
}

export function hasChangeTable(qrCode, tableSessionId) {
    const url = Api.buildUrl(`${basePath}/haschangetable`);
    return Api.postData(url, { qrCode, tableSessionId }).then((response) => response.json());
}
